import { ThemeProvider } from "@ds/react";
import { cnpSeguradora } from "@ds/tema-cnp";

import Footer from "components/Footer";
import GlobalErrorModal from "components/GlobalErrorModal";
import Header from "components/Header";
import ScrollTop from "components/ScrollTop";
import AppContextProvider from "contexts/AppContext";

import { BrowserRouter } from "react-router-dom";
import AppRoutes from "routes/AppRoutes";

function App() {
  return (
    <AppContextProvider>
      <ThemeProvider theme={cnpSeguradora}>
        <BrowserRouter>
          <Header />
          <main>
            <article>
              <AppRoutes />
            </article>
          </main>
          <Footer />
          <ScrollTop />
          <GlobalErrorModal />
        </BrowserRouter>
      </ThemeProvider>
    </AppContextProvider>
  );
}

export default App;
